import { connect } from 'react-redux';
import ModalBalanceAdjustment from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(ModalBalanceAdjustment);
